import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { TRACK_ID } from "../../../../../utility/enum";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { getAllianceLeadFromMoneyTapInput } from "../../../../../utility/commonUtils";
const OfferPage = ({ formData, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [params] = useSearchParams();
  const [isTncChecked, setIsTncChecked] = useState(true);
  const mobile = localStorage.getItem("mobile");
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const token = user?.token;
  const leadFromStore = useSelector((state) => state?.app?.lead);
  const leadIdFromStore = leadFromStore?.id;
  const [failedList, setFailedList] = useState([]);

  let bucket2 = ["L&T", "IndusInd", "Tata Capital"];
  const lenderOrder = [
    "662752eb65fdba1a48d6e482",
    "687882db884a4422ccafa173", // IndusInd missing
    "67ef646df80610d286084e60",
    "662752eb65fdba1a48d6e464",
    "666ec1953a9a969d8f9980f1",
    "6855600d0313d8d083045d13",
    "662752eb65fdba1a48d6e474",
    "6851271c3a9753dd00d85475",
    "68b7cb3721c19b150d2893da", // Creditsea missing
  ];
  console.log(offers);
  const lenderNames = [
    "L&T",
    "IndusInd",
    "Hero",
    "MV",
    "Kissht",
    "Raam Fincorp",
    "TrueBalance",
    "Fatakpay",
    "Creditsea",
  ];
  const [ipAddress, setIpAddress] = useState("");

  const sortedOffers = [...offers].sort((a, b) => {
    const indexA = lenderOrder.indexOf(a.lender_id);
    const indexB = lenderOrder.indexOf(b.lender_id);

    // If lender_id is not in sequence, place it at the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });



  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // ipAddress = data?.ip;
        setIpAddress(data?.ip);
        console.log("IP Address:", data?.ip);
        console.log(ipAddress);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  useEffect(() => {
    // if (formData.stepDone === 3 && !leadId) {
    submitLead();
    // }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(sortedOffers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (offers.length > 0) {
      setShowOfferHeaderLogo(false);
    }
  }, [offers]);

  const pushHDMLead = async (leadId) => {
    try {
      const res = await callApi(
        "v1/lead/hdm_lead_push",
        "post",
        { lead_id: leadId },
        "core",
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjA2YWIzNmE1NjE2MjFkNGZiYTllODEiLCJjb250YWN0X25hbWUiOiJNdWt1bCBTaGFybWEiLCJjb3VudHJ5X2NvZGUiOiI5MSIsInBhbmNhcmQiOiJPTFRQUzEyNTVSIiwiY29udGFjdF9waG9uZSI6Ijk2MzQxMDkzNDkiLCJpYXQiOjE3MTE3MTMwNzh9.a0hEtlBumS9YJ9vd0arGJk1feNZjxQ-CwSWx6KcU8ks"
      );

      return res; // return response to caller
    } catch (err) {
      console.error("HDM lead push failed:", err);
      return { status: "Error", error: err };
    }
  };

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];

        // const hardcodedLender = {
        //   _id: "662752eb65fdba1a48d6e482",
        //   lender_name: "L&T",
        // };

        const mergedLenders = [...apiLenders];

        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const submitLead = async () => {
    setUserClickData({
      event_name: "professional-details-submit-for-pl-non-pan",
      user_id: formData.mobile || mobile || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });

    try {
      const newLeadId = leadIdFromStore;
      setLeadId(newLeadId);

      // Step 1: Process Lead
      const processLeadRes = await callApi(
        "v1/lead/process-lead-for-loan-zv4",
        "post",
        { contact_phone: mobile || formData.mobile },
        "core",
        user.token
      );

      if (processLeadRes?.status === "Success") {
        // Step 2: Get lender call list
        const lenderResponse = await callApi(
          "v1/lender_api_call/list",
          "post",
          {
            filters: {
              lead_id: newLeadId,
              lender_name: {
                $in: ["UnityBank", "Incred", "Tata Capital", "L&T"],
              },
            },
            pageSize: 10,
            pageNum: 1,
          },
          "loan_service"
        );

        // Step 3: Get lender meta
        const lenderMetaRes = await callApi(
          "v1/lender/list",
          "post",
          {
            filters: {
              name: { $in: ["UnityBank", "Incred", "Tata Capital", "L&T"] },
            },
            pageSize: 10,
            pageNum: 1,
          },
          "loan_service",
          token
        );

        const callList = lenderResponse?.data?.lender_api_callList || [];
        const metaList = lenderMetaRes?.data?.lenderList || [];

        const hasCall = (name) =>
          callList.some(
            (e) => e.lender_name.toLowerCase() === name.toLowerCase()
          );

        const getMeta = (name) =>
          metaList.find((m) => m.name.toLowerCase() === name.toLowerCase());

        // Helper push function
        const push = async (name, lender_id) => {
          await callApi(
            "v1/lead/bulk-lead-push-by-leadId",
            "post",
            {
              leads: [{ lead_id: newLeadId }],
              lender_name: name,
              lender_id,
            },
            "core",
            token
          );
        };

        // Push needed lenders
        if (!hasCall("UnityBank")) {
          await push("UnityBank", "67762d497ae263a3ec86347e");
        }

        const incredMeta = getMeta("Incred");
        if (!hasCall("Incred") && incredMeta?.otp_page_api_push) {
          await push("Incred", "68401febe871a7a9504dc2e3");
        }

        const tataMeta = getMeta("Tata Capital");
        if (!hasCall("Tata Capital") && tataMeta?.otp_page_api_push) {
          await push("Tata Capital", "66b5b42d123877ad47aa4745");
        }

        const landtMeta = getMeta("L&T");
        if (!hasCall("L&T") && landtMeta?.otp_page_api_push) {
          await push("L&T", "662752eb65fdba1a48d6e482");
        }

        // Track event after lender pushes
        setUserClickData({
          event_name: "process-lead-for-pl-non-pan",
          user_id: formData.mobile || mobile || "No User ID found here",
          affiliate_id: params.get("aff_id") || "No Aff_id found",
        });

        // -----------------------------
        // POLL OFFERS AND WAIT FOR IT
        // -----------------------------
        const pollOffers = async (attempt = 1) => {
          try {
            const result = await fetchOffers(newLeadId);

            const hasOffer =
              result?.success &&
              Array.isArray(result.offers) &&
              result.offers.length > 0;

          

            if (attempt === 6) {
              console.log("No offer found after 6 attempts");
              return false;
            }

            return new Promise((resolve) =>
              setTimeout(
                async () => resolve(await pollOffers(attempt + 1)),
                5000
              )
            );
          } catch (err) {
            console.log("Poll error", err);

            if (attempt === 6) return false;

            return new Promise((resolve) =>
              setTimeout(
                async () => resolve(await pollOffers(attempt + 1)),
                1000
              )
            );
          }
        };

        // Wait for polling to finish
        await pollOffers();

        // -----------------------------
        // HDM MUST ALWAYS RUN
        // -----------------------------
        await pushHDMLead(newLeadId, user.token);

        setIsFinished(true);
      }
    } catch (err) {
      toast("Some error occurred", { hideProgressBar: true, type: "error" });
      console.log(err);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    try {
      // 1️⃣ Fetch offers
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        user.token
      );

      if (res.status === "Success" && res.data?.offers?.length > 0) {
        console.log(res);

        // 2️⃣ Update offer priority
        const priorityRes = await callApi(
          `v1/finbud_data/finbud_update_priority/${leadId}`,
          "post",
          res,
          "loan",
          user.token
        );

        if (
          priorityRes.status === "Success" &&
          Array.isArray(priorityRes.data?.offers)
        ) {
          const offers = priorityRes.data.offers;

          // ✅ 3️⃣ Fetch NEW lender details (Successlist)
          const lenderListRes = await callApi(
            `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
            "post",
            {},
            "loan",
            user.token
          );

          // ✅ 4️⃣ Build map from Successlist
          let lenderMap = {};
          if (Array.isArray(lenderListRes.data?.FailList)) {
            setFailedList(lenderListRes.data?.FailList);
          }

          if (
            lenderListRes.status === "Success" &&
            Array.isArray(lenderListRes.data?.Successlist)
          ) {
            lenderMap = Object.fromEntries(
              lenderListRes.data.Successlist.map((lender) => [
                lender.lender_id,
                lender,
              ])
            );
          }

          // ✅ 5️⃣ Enrich offers with new lender fields
          const enrichedOffers = offers.map((offer) => {
            const lender = lenderMap[offer.lender_id] || {};

            return {
              ...offer,
              apr: lender.apr ?? "",
              kfs_doc: lender.kfs_doc ?? "",
              credit_limit: lender.web_offer ?? "",
              penal_charges: lender.penal_charges ?? "",
              processing_fee: lender.processing_fee ?? "",
              interest_rate: lender.web_interest ?? null, // ✅ updated key
              lender_name: lender.lender_name ?? offer.lender_name,
            };
          });

          // ✅ 6️⃣ Sort by priority
          const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

          // ✅ 7️⃣ Filter for active lenders
          const filteredOffers = activeLenders.length
            ? sortedOffers.filter((offer) =>
                activeLenders.some((lender) => lender._id === offer.lender_id)
              )
            : sortedOffers;

          // ✅ 8️⃣ Bucket2 filter (unchanged)
          const bucket2Offers = filteredOffers.filter((offer) =>
            bucket2.includes(offer.lender_name)
          );

          if (bucket2Offers.length > 0) {
            dispatch(setOffers(bucket2Offers));
          } else {
            dispatch(setOffers(filteredOffers));
          }

          // ✅ 9️⃣ Handle finish state
          if (priorityRes.data.lead?.all_responses) {
            setIsFinished(
              priorityRes.data.lead.all_responses ===
                priorityRes.data.lead.total_response
            );
          } else {
            setIsFinished(true);
          }

          return {
            success: true,
            offers: bucket2Offers.length > 0 ? bucket2Offers : filteredOffers,
          };
        }
      }

      return { success: false, offers: [] };
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return { success: false, offers: [] };
    }
  };

  return (
    // <div id="offer-page-v5" >
    <div
      id={
        sortedOffers.some((offer) => bucket2.includes(offer.lender_name))
          ? "offer-page-v9-bucket2"
          : "offer-page-v9-bucket1"
      }
    >
      {offers.length > 0 ? (
        <>
          <div className="final-offers-container-v5">
            <>
              {/* <video
                className="background-video1"
                src="/assets/img/BG video.mp4"
                autoPlay
                loop
                muted
              /> */}
              <img
                src="/assets/img/Offer page BG image 1.png"
                alt="Square Check Background"
                className="background-overlay-img-offer"
              />
            </>
            <div className="offer-bg-layer-v5">
              <h2 className="congrats-text1">Congratulations!</h2>
              <h3 className="sub-text1">You’re Pre-Qualified for</h3>
              <h3 className="sub-text1">a Personal Loan!</h3>
            </div>
          </div>

          <div className="offer-cards-container-new1">
            {sortedOffers.map((offer) => (
              <OfferCard
                key={offer._id}
                offer={offer}
                isExpanded={expandedOfferId === offer._id}
                onExpand={() => setExpandedOfferId(offer._id)}
              />
            ))}
            <div
              className="p-4 rounded-xl bg-white-900/80  backdrop-blur-md shadow-lg mx-2"
              style={{ backgroundColor: "white" }}
            >
              {/* Note Header */}
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-semibold uppercase tracking-wide text-red-500">
                  Note
                </span>
              </div>

              {/* Note Text */}
              <p className="text-sm text-black-300 mb-4 leading-relaxed">
                {failedList?.length > 0 && (
                  <p className="text-sm text-black-300 mb-2">
                    There are no matching offers for your request from:{" "}
                    {failedList.join(", ")}
                  </p>
                )}
              </p>
            </div>
            <p className="disclaimer-offer-new-text-v5">
              Choose from these incredible offers that best suit your needs
            </p>
            <p className="disclaimer-text1">
              *These pre-approved offers are subject to change at discretion of
              Bank / NBFC after receiving all your documents and details. Final
              offer will be based on risk policy of Bank / NBFC. We do not
              guarantee that final offer will be same as Pre-approved offer.
            </p>
          </div>
        </>
      ) : isFinished ? (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              There is no offer for you currently.
            </h2>
          </div>
        )
      ) : (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              Please wait while we are searching best offers for you
            </h2>
          </div>
        )
      )}
    </div>
  );
};

export default OfferPage;
